import { getCdnUrl } from '@/lib/helpers/common';
import { isHyperlinkBanner, openBannerHyperlink } from '@/utils';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
const settings = {
  adaptiveHeight: true,
  className: 'center',
  centerMode: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  dots: false,
  variableWidth: true,
  autoplay: true,
  cssEase: 'linear',
  // nav: true,
  rows: 1,
  responsive: [{
    breakpoint: 769,
    settings: {
      centerMode: true,
      variableWidth: false
    }
  }]
};
function FullWidthSlider() {
  const router = useRouter();
  const {
    home
  } = useSelector(store => store.common);
  const orderData = useSelector(store => store.order).order;

  // Filter out WELCOME_BANNER type - those are shown in modal popup only
  // Also filter by orderTypes if banner has orderTypes defined
  const regularBanners = home?.BANNER?.filter(banner => {
    if (banner.type === 'WELCOME_BANNER') {
      return false;
    }

    // If banner has orderTypes, check if current order type is included
    if (banner.orderTypes && banner.orderTypes.length > 0) {
      return banner.orderTypes.includes(orderData?.type);
    }

    // If no orderTypes defined, show the banner (ignore condition)
    return true;
  }) || [];
  if (!regularBanners?.length) {
    return null;
  }
  function handleBannerClick(bannerData) {
    // Check if banner has a link
    if (!bannerData?.link) {
      return; // No link, do nothing
    }

    // HYPERLINK banners point outside the app — open in a new tab.
    if (isHyperlinkBanner(bannerData)) {
      openBannerHyperlink(bannerData);
      return;
    }
    const [type, id] = bannerData.link.split('/');
    let url = '';
    if (type === 'PRODUCT' && id) {
      url = `/categories?modalType=productDetails&id=${id}&mode=create&companyId=${bannerData.companyId}`;
    } else if (type === 'CATEGORY' && id) {
      url = `/categories#${id}`;
    }
    if (url) {
      router.push(url);
    }
  }
  const items = regularBanners?.map(item => {
    return <button className={`item ${item?.link ? 'clickable-banner' : 'non-clickable-banner'}`} key={item.web?.split('=').pop()} onClick={() => handleBannerClick(item)}>
                <Image src={getCdnUrl(item.web)} alt={item.description} width={100} height={100} quality={75} layout="responsive" />
            </button>;
  });
  return <div className={`offersContainer ${regularBanners?.length === 1 ? 'single-item' : ''}`} data-sentry-component="FullWidthSlider" data-sentry-source-file="FullwidthSlider.jsx">
            <div className="slider-container">
                <Slider {...{
        ...settings,
        infinite: regularBanners?.length > 1,
        dots: false,
        arrows: regularBanners?.length > 1
      }} data-sentry-element="Slider" data-sentry-source-file="FullwidthSlider.jsx">
                    {items}
                </Slider>
            </div>
        </div>;
}
FullWidthSlider.propTypes = {
  data: PropTypes.array
};
export default FullWidthSlider;